// extracted by mini-css-extract-plugin
module.exports = {"Title":"SectionTitle-module--Title--2rtaD","Large":"SectionTitle-module--Large--35LFj","Normal":"SectionTitle-module--Normal--22lU4","Small":"SectionTitle-module--Small--1RLeH"};